import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core'
import { ButtonModule } from 'primeng/button'
import { CommonModule } from '@angular/common'
import { ControlContainer, FormGroupDirective } from '@angular/forms'
import { Tooltip } from 'primeng/tooltip'
import { PermissionService } from '@app/core/auth/services/permission.service'
import { CategoryService } from '@app/core/auth/services/category.service'

@Component({
  selector: 'albert-override-wrapper',
  standalone: true,
  imports: [ButtonModule, CommonModule, Tooltip],
  templateUrl: './albert-override-wrapper.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class AlbertOverrideWrapper {
  public readonly isVisible = input<boolean>(false)
  public readonly disabled = input<boolean>(false)
  public readonly visibilityChange = output()
  public readonly tooltipLabel = input<string>('')

  private readonly permissionService = inject(PermissionService)
  private readonly categoryService = inject(CategoryService)

  public readonly isEffectiveDisabled = computed(() => {
    if (this.disabled()) {
      return true
    }
    const cat = this.categoryService.activeCategory()
    return cat === null ? false : !this.permissionService.canEdit(cat)
  })
}
